"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function StringArrayTemplate() {
    return `
        const {stringArrayName} = [{stringArray}];
    `;
}
exports.StringArrayTemplate = StringArrayTemplate;
